import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

// import { IS_ADDING_CHIP, SET_INSERTED_DATA_DISPLAY_MODE, SET_DATA_CHIP_DATA } from './mutations';
import { SET_INSERTED_DATA_DISPLAY_MODE } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setIsAddingChip = buildActionObject('setIsAddingChip');
export const setInsertedDataDisplayMode = buildActionObject('setInsertedDataDisplayMode');
export const setDataChipData = buildActionObject('setDataChipData');

const actions = {
	...StoreModuleService.createDefaultActions(),
	// [setIsAddingChip.action]({ commit }, payload) {
	// 	commit(IS_ADDING_CHIP, payload);
	// },
	[setInsertedDataDisplayMode.action]({ commit }, payload) {
		commit(SET_INSERTED_DATA_DISPLAY_MODE, payload);
	},
	// [setDataChipData.action]({ commit }, payload) {
	// 	commit(SET_DATA_CHIP_DATA, payload);
	// },
};

export default actions;
